import React from 'react';
import ".././css/card.css"
import { Link } from 'react-router-dom';





  

function Card(props) {

    return (
        <div className="flipper-container" style={{background: props.background_color}}>
            <div className="flipper">
                <div className="front">
                    <div className="ImgLogo">
                        <img src={process.env.PUBLIC_URL + '/' + props.image + '.png'} alt="" />
                    </div>
                        <h1 className="text1">{props.text1}</h1>
                    
                        <br />
                        <div className="square" style={{background: props.square_color}}></div>
                </div>
                <div className="back" style={{background: props.background_color}}>
                    <h1 className="text2">{props.text2}</h1>
                    <br />
                    <p className="textinfo"><b>{props.textinfo1}</b></p>
                    <br />
                    <p className="textinfo"><b>{props.textinfo2}</b></p>
                    <br />
                    <p className="textinfo"><b>{props.textinfo3}</b></p>
                    <br />

                    <Link className="buybutton" to="/">
                  <b className="textinfo">Se mere</b>
                    </Link>
                </div>
            </div>
        </div>
        
  );
}

export default Card;